import React from "react";
import {Link} from "react-router-dom";
import {Image} from "antd"

const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp"];
const videoExtensions = ["mp4", "webm", "ogg", "mov"];
const audioExtensions = ["mp3", "wav", "ogg", "aac"];

const getFileExtension = (filename) => {
    return filename.split(".").pop().toLowerCase();
};

const getFileNameFromUrl = (url) => {
    try {
        return decodeURIComponent(url.split("/").pop());
    } catch {
        return url;
    }
};

const FileViewer = ({fileUrl}) => {
    const fileName = getFileNameFromUrl(fileUrl);
    const ext = getFileExtension(fileName);

    const isImage = imageExtensions.includes(ext);
    const isVideo = videoExtensions.includes(ext);
    const isAudio = audioExtensions.includes(ext);

    return (

        <div className="flex flex-col items-center justify-center">
            {isImage && (
                <Image

                    alt="basic"
                    src={fileUrl}
                />
                // <img
                //     src={fileUrl}
                //     alt={fileName}
                //     className="rounded-xl max-h-96 object-contain"
                // />
            )}

            {isVideo && (
                <video
                    controls
                    className="rounded-xl max-h-96 w-full object-contain"
                >
                    <source src={fileUrl} type={`video/${ext}`}/>
                    مرورگر شما از ویدیو پشتیبانی نمی‌کند.
                </video>
            )}

            {isAudio && (
                <audio controls className="w-full">
                    <source src={fileUrl} type={`audio/${ext}`}/>
                    مرورگر شما از صوت پشتیبانی نمی‌کند.
                </audio>
            )}

            {!isImage && !isVideo && !isAudio && (
                <div className="text-center">
                    <p className="mb-2 text-gray-600">فایل ناشناخته: {fileName}</p>
                    <Link type="primary" to={fileUrl} target={'_blank'} download>
                        دانلود فایل
                    </Link>
                </div>
            )}
        </div>

    );
};

export default FileViewer;